"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _babelHelperVueJsxMergeProps = _interopRequireDefault(require("@vue/babel-helper-vue-jsx-merge-props"));
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.array.fill.js");
var _utils = require("../utils");
var _functional = require("../utils/functional");
var _lottie = _interopRequireDefault(require("../lottie"));
var _use = (0, _utils.use)('loading'),
  sfc = _use[0],
  bem = _use[1];
function Loading(h, props, slots, ctx) {
  var color = props.color,
    size = props.size,
    type = props.type,
    vertical = props.vertical;
  var Spinner = new Array(12).fill(null).map(function (item, index) {
    return h("i", {
      "style": {
        opacity: 1 - index * 0.08,
        transform: "rotate(" + (360 - 360 / 12 * index) + "deg)"
      }
    });
  });
  var Circular = h("svg", {
    "class": bem('circular'),
    "attrs": {
      "viewBox": "25 25 50 50"
    }
  }, [h("circle", {
    "attrs": {
      "cx": "50",
      "cy": "50",
      "r": "20",
      "fill": "none"
    }
  })]);
  var Hunter = h("img", {
    "attrs": {
      "src": "https://pic5.zhuanstatic.com/zhuanzh/n_v246a4f55c8c89411e9c297b5f9d18f84a.gif"
    }
  });
  return h("div", (0, _babelHelperVueJsxMergeProps.default)([{
    "class": [bem([type]), vertical && 'z-loading--vertical'],
    "style": {
      color: color
    }
  }, (0, _functional.inherit)(ctx, true)]), [type === 'zz' && h(_lottie.default, {
    "attrs": {
      "options": {
        path: 'https://s1.zhuanstatic.com/common/open/zzui_lottie_loading_v1.json'
      },
      "height": "50",
      "width": "50"
    }
  }), type === 'page' && h(_lottie.default, {
    "attrs": {
      "options": {
        path: 'https://s1.zhuanstatic.com/common/open/zzui_lottie_page.json'
      },
      "height": "35",
      "width": "86"
    }
  }), type === 'drop-down' && h(_lottie.default, {
    "attrs": {
      "options": {
        path: 'https://s1.zhuanstatic.com/common/open/zzui_lottie_drop-down_v1.json'
      },
      "height": "35",
      "width": "90"
    }
  }), type === 'spinner' || type === 'circular' || type === 'hunter' ? h("span", {
    "class": bem('spinner', type),
    "style": {
      width: size,
      height: size
    }
  }, [type === 'spinner' && Spinner, type === 'circular' && Circular, type === 'hunter' && Hunter]) : '', type === 'box-spinner' && h("span", {
    "class": bem('box-spinner', type),
    "style": {
      width: size,
      height: size
    }
  }, [Spinner]), slots.default && h("span", {
    "class": bem('text')
  }, [slots.default()])]);
}
Loading.props = {
  size: String,
  color: String,
  vertical: Boolean,
  type: {
    type: String,
    default: 'circular'
  }
};
var _default = sfc(Loading);
exports.default = _default;